import {
  DAYS_CREATE_FAIL,
  DAYS_CREATE_REQUEST,
  DAYS_CREATE_SUCCESS,
  DAYS_LIST_FAIL,
  DAYS_LIST_REQUEST,
  DAYS_LIST_SUCCESS,
  DAYS_LIST_FAIL_ID,
  DAYS_LIST_REQUEST_ID,
  DAYS_LIST_SUCCESS_ID,
  DAYS_UPDATE_FAIL,
  DAYS_UPDATE_REQUEST,
  DAYS_UPDATE_SUCCESS,
  DAYS_PATCH_FAIL,
  DAYS_PATCH_REQUEST,
  DAYS_PATCH_SUCCESS,
  DAYS_SINGLE_FAIL,
  DAYS_SINGLE_REQUEST,
  DAYS_SINGLE_SUCCESS,
  DAYS_DELETE_FAIL,
  DAYS_DELETE_REQUEST,
  DAYS_DELETE_SUCCESS,
} from "../constants/daysConstants";

export const dayListReducer = (state = { days: [] }, action) => {
  switch (action.type) {
    case DAYS_LIST_REQUEST:
      return { loading: true };
    case DAYS_LIST_SUCCESS:
      return { loading: false, days: action.payload };
    case DAYS_LIST_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const dayListIDReducer = (state = { days: [] }, action) => {
  switch (action.type) {
    case DAYS_LIST_REQUEST_ID:
      return { loading: true, days: [] };
    case DAYS_LIST_SUCCESS_ID:
      return { loading: false, days: action.payload };
    case DAYS_LIST_FAIL_ID:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const dayCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case DAYS_CREATE_REQUEST:
      return { loading: true };
    case DAYS_CREATE_SUCCESS:
      return { loading: false, success: true };
    case DAYS_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const daySingleReducer = (
  state = { day: null, version: 0, fieldMeta: {} },
  action,
) => {
  switch (action.type) {
    case DAYS_SINGLE_REQUEST:
      return { loading: true, version: 0, fieldMeta: {} };
    case DAYS_SINGLE_SUCCESS: {
      // The GET response is the flat day object with optimistic-concurrency
      // metadata folded in via _version and _fieldMeta. Strip them so the
      // rest of the app keeps reading day.startScore etc unchanged.
      const payload = action.payload || {};
      const { _version, _fieldMeta, ...flat } = payload;
      return {
        loading: false,
        day: flat,
        version: typeof _version === "number" ? _version : 0,
        fieldMeta: _fieldMeta || {},
      };
    }
    case DAYS_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    // PATCH_SUCCESS bumps version/fieldMeta but does NOT replace `day`.
    // Local component state holds the user's in-flight edits; a server
    // round-trip must not clobber characters typed during the request.
    // (Cross-device live updates land via the Stage 3 socket layer.)
    case DAYS_PATCH_SUCCESS: {
      const payload = action.payload || {};
      return {
        ...state,
        patchInflight: false,
        version:
          typeof payload.version === "number" ? payload.version : state.version,
        fieldMeta: payload.fieldMeta || state.fieldMeta,
        patchError: undefined,
      };
    }
    case DAYS_PATCH_REQUEST:
      return { ...state, patchInflight: true };
    case DAYS_PATCH_FAIL:
      return { ...state, patchInflight: false, patchError: action.payload };
    default:
      return state;
  }
};

export const dayUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case DAYS_UPDATE_REQUEST:
      return { loading: true };
    case DAYS_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case DAYS_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const dayDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DAYS_DELETE_REQUEST:
      return { loading: true };
    case DAYS_DELETE_SUCCESS:
      return { loading: false, success: true };
    case DAYS_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
